import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"
// import Resume from "../templates/resume"

const AbautPage = () => (
  <Layout>
    <SEO title="About" />
    {/* <Resume/> */}
  </Layout>
)

export default AbautPage
